import { buildUrl } from 'hub-http/helpers/url';
/**
 * @deprecated {@link https://docs.google.com/document/d/10dKkHouJGDQmXp0T_FkgkgZMZbdPbjJCBDYYPBXza-8/edit#bookmark=id.olzxeaegmb2t more information}
 */
export const getDataSyncAuthConfigUrl = appId => `/api/integration-auth-flows/v1/apps/${appId}/config`;

/**
 * Fetches the configuration for authenticating the specified `authenticatorId`.
 * Also includes the `appName` for modal text translation purposes.
 * The definition of the app in the `appName` used here can be found from {@link https://paper.dropbox.com/doc/Apps-connectors-and-unified-auth--CI9UNFXvtY2vzlRmkTc5fjplAg-G6xU4hIMkkplwewO20otm this link}.
 * For example, Zoho CRM, Zoho Books, and Zoho Invoice will use the same authenticatorId `zoho`, but their the modal text will depend on the `appName` provided.
 */
export const getUnifiedAuthConfigUrl = authenticatorId => `unified-auth/v1/authenticators/${authenticatorId}/start`;

/**
 * Creates or updates an account's credentials in the platform
 *
 * The params will contain all the required data as specified by the
 * authentication configuration.
 * This includes an OAuth code if the app authenticates via OAuth.
 */
export function postAccountCredentials(http, portalId, appId, accountId, params) {
  return http.post(accountId ? `/api/sync-bridge/v3/accounts/${accountId}/credentials` : '/api/sync-bridge/v3/install/finish', {
    data: params,
    query: {
      portalId,
      appId: appId.toString()
    }
  });
}
/**
 * Fetches the session info for the given `sessionId`.
 * This is used to check the status of the authentication flow.
 */
export function fetchSessionInfo(http, portalId, sessionId) {
  return http.get(`unified-auth/v1/authenticators/session/${sessionId}`, {
    query: {
      portalId
    }
  }).then(response => Object.assign({}, response, {
    params: new Map(Object.entries(response.params || {}))
  }));
}
export function getAppInfoUrl(appId) {
  return buildUrl({
    path: `/api/sync-bridge/v5/apps/${appId}`
  });
}

/**
 * Deletes a secret from the unified auth service.
 */
export function deleteSecret(http, portalId, authenticatorId, secretId) {
  return http.delete(`unified-auth/v1/authenticators/${authenticatorId}/secrets/${secretId}`, {
    query: {
      portalId
    }
  });
}